import * as React from 'react'
import {
    BlockSpacer,
    currentMedia,
    GridContainer,
    GridItem
} from '../../../../../styledComponents/ResponsiveConvenience'
import {APPLY_CATEGORY} from '../../../../../CodeMaster'
import {convertToRoomNumberForResident} from '../../../../common/util/Natutil'
import {
    NatResidentLoginInfoSessionStorageHelper,
    ResidentLoginInfoSessionStorageKey
} from '../../../../common/authentication/NatResidentLoginInfoSessionStorageHelper'
import NatResidentApplicationDetailConfirmItem from '../../common/resident/NatResidentApplicationDetailConfirmItem'
import {DisplayItemLabelDiv} from '../../../../../styledComponents/DisplayItem'
import {Box} from '@mui/material'
import styled from 'styled-components'
import {Colors, FontWeights} from '../../../../../styledComponents/Constants'
import {FileInformation} from '../../../../../components/applications/ResidentAttachmentFileArea'
import {getFormattedDate} from '../../contactAddressOnEmergencies/helper/NatContactAddressOnEmergencyHelper'

interface Props {
    applicantFamilyName: string
    applicantFirstName: string
    heavyWeightGoodsDetail: string
    carryingStartDate: string
    carryingEndDate: string
    applyToAttachment: FileInformation[]
    applyFlag?: boolean
}

const NatResidentHeavyLoadsCarryConfirm = ({applyFlag = true, ...otherProps}: Props) => {
    const {
        applicantFamilyName,
        applicantFirstName,
        heavyWeightGoodsDetail,
        carryingStartDate,
        carryingEndDate,
        applyToAttachment
    } = otherProps

    const applyCategoryLabel = APPLY_CATEGORY.HEAVY_GOODS_APPLY.label
    const applicantRoom = NatResidentLoginInfoSessionStorageHelper
            .getStringItemOrNull(ResidentLoginInfoSessionStorageKey.SELECTED_CONDOMINIUM_NAME) + '　' +
        NatResidentLoginInfoSessionStorageHelper
            .getStringItemOrNull(ResidentLoginInfoSessionStorageKey.SELECTED_RIDGENAME) + ' ' +
        convertToRoomNumberForResident(
            NatResidentLoginInfoSessionStorageHelper
                .getStringItemOrNull(ResidentLoginInfoSessionStorageKey.SELECTED_ROOM_NUMBER)
        )
    const carryingStartDateLabel = (carryingStartDate) ? getFormattedDate(carryingStartDate) : ''
    const carryingEndDateLabel = (carryingEndDate) ? getFormattedDate(carryingEndDate) : ''

    return (<>
        {applyFlag === true &&
            <>
                <NatResidentApplicationDetailConfirmItem
                    title={'申請区分'}
                    items={[applyCategoryLabel]}
                />
                <BlockSpacer height={'5px'}/>
                <NatResidentApplicationDetailConfirmItem
                    title={'申請者'}
                    items={[applicantRoom, `${applicantFamilyName} ${applicantFirstName}`]}
                />
            </>
        }
        <BlockSpacer height={'5px'}/>
        <NatResidentApplicationDetailConfirmItem
            title={'重量物'}
            items={[heavyWeightGoodsDetail]}
        />
        <BlockSpacer height={'5px'}/>
        <NatResidentApplicationDetailConfirmItem
            title={'重量物の搬入等期間'}
            items={[
                '開始日: ' + `${carryingStartDateLabel}`,
                '終了日: ' + `${carryingEndDateLabel}`
            ]}
        />
        <BlockSpacer height={'5px'}/>
        <ItemDiv>
            <GridContainer>
                <GridItem over={3}><DisplayItemLabelDiv><Box mr={'5px'}>添付資料</Box></DisplayItemLabelDiv>
                </GridItem>
                <GridItem over={9}>
                    {(applyToAttachment && applyToAttachment.map((attachmentFile, index) => (
                        <TextContents key={index}>
                            {attachmentFile.fileName}
                        </TextContents>
                    )))}
                </GridItem>
            </GridContainer>
        </ItemDiv>
    </>)
}

NatResidentHeavyLoadsCarryConfirm.displayName = 'NatResidentHeavyLoadsCarryConfirm'
export default NatResidentHeavyLoadsCarryConfirm

const ItemDiv = styled.div`
  background-color: ${Colors.Surface};
 ${currentMedia.lessThan('sp')`
    margin: 0px -15px;
  `}
  padding: 20px 15px 20px 15px;
`
const TextContents = styled.div`
  font-weight: ${FontWeights.Bold};
  overflow-wrap: anywhere;
`